export const unwrapNodes = (edges) => edges?.map(({ node }) => node);
